// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"c90d9103","99":"b51963c4","294":"d93e9b5e","455":"46eef4b9","488":"08d2694d","579":"b5ee796b","950":"f7492613"}[chunkId] + ".chunk.js";
};